module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/188.25706c19.png";